import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { AddIcon, MergeIcon, MinusIcon, SplitModuleIcon } from 'foundations-assets';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InsertButton = props => /*#__PURE__*/_jsx(IconButton, Object.assign({
  "data-test-id": "insert-cells-btn"
}, props, {
  children: /*#__PURE__*/_jsx(AddIcon, {})
}));
const DeleteButton = props => /*#__PURE__*/_jsx(IconButton, Object.assign({
  "data-test-id": "delete-cells-btn"
}, props, {
  children: /*#__PURE__*/_jsx(MinusIcon, {})
}));
const InsertDropdownButton = ({
  cellsSpanRowsCount,
  cellsSpanColsCount,
  onInsertRowAbove,
  onInsertRowBelow,
  onInsertColumnLeft,
  onInsertColumnRight
}) => {
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "RichTextLib.table.cellFloaty.tooltip.insert"
    }),
    placement: "top",
    children: /*#__PURE__*/_jsx(Dropdown, {
      Button: InsertButton,
      buttonSize: "xs",
      buttonUse: "tertiary-light",
      children: /*#__PURE__*/_jsxs(List, {
        children: [/*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(Button, {
            "data-test-id": "insert-row-above-btn",
            onClick: onInsertRowAbove,
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "RichTextLib.table.cellFloaty.insert.rowAbove",
              options: {
                count: cellsSpanRowsCount
              }
            })
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(Button, {
            "data-test-id": "insert-row-below-btn",
            onClick: onInsertRowBelow,
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "RichTextLib.table.cellFloaty.insert.rowBelow",
              options: {
                count: cellsSpanRowsCount
              }
            })
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(Button, {
            "data-test-id": "insert-col-left-btn",
            onClick: onInsertColumnLeft,
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "RichTextLib.table.cellFloaty.insert.colLeft",
              options: {
                count: cellsSpanColsCount
              }
            })
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(Button, {
            "data-test-id": "insert-col-right-btn",
            onClick: onInsertColumnRight,
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "RichTextLib.table.cellFloaty.insert.colRight",
              options: {
                count: cellsSpanColsCount
              }
            })
          })
        })]
      })
    })
  });
};
function DeleteDropdownButton({
  cellsSpanRowsCount,
  cellsSpanColsCount,
  onDeleteRow,
  onDeleteColumn
}) {
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "RichTextLib.table.cellFloaty.tooltip.delete"
    }),
    placement: "top",
    children: /*#__PURE__*/_jsx(Dropdown, {
      Button: DeleteButton,
      buttonSize: "xs",
      buttonUse: "tertiary-light",
      children: /*#__PURE__*/_jsxs(List, {
        children: [/*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(Button, {
            "data-test-id": "delete-row-btn",
            onClick: onDeleteRow,
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "RichTextLib.table.cellFloaty.delete.row",
              options: {
                count: cellsSpanRowsCount
              }
            })
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(Button, {
            "data-test-id": "delete-col-btn",
            onClick: onDeleteColumn,
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "RichTextLib.table.cellFloaty.delete.col",
              options: {
                count: cellsSpanColsCount
              }
            })
          })
        })]
      })
    })
  });
}
function MergeSplitButton({
  showMerge,
  showSplit,
  onMergeCells,
  onSplitCells
}) {
  if (!showMerge && !showSplit) return null;
  const MergeSplitIcon = showMerge ? MergeIcon : SplitModuleIcon;
  const tooltipMessage = showMerge ? 'RichTextLib.table.cellFloaty.tooltip.merge' : 'RichTextLib.table.cellFloaty.tooltip.splitModule';
  const onClick = showMerge ? onMergeCells : onSplitCells;
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "top",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: tooltipMessage
    }),
    children: /*#__PURE__*/_jsx(IconButton, {
      "data-test-id": "merge-split-btn",
      size: "xs",
      use: "tertiary-light",
      onClick: onClick,
      children: /*#__PURE__*/_jsx(MergeSplitIcon, {})
    })
  });
}
function TableFloatyPopoverBody({
  showMerge,
  showSplit,
  cellsSpanRowsCount,
  cellsSpanColsCount,
  onInsertRowAbove,
  onInsertRowBelow,
  onInsertColumnLeft,
  onInsertColumnRight,
  onDeleteRow,
  onDeleteColumn,
  onMergeCells,
  onSplitCells
}) {
  return /*#__PURE__*/_jsxs(ButtonGroup, {
    orientation: "horizontal",
    children: [/*#__PURE__*/_jsx(InsertDropdownButton, {
      cellsSpanRowsCount: cellsSpanRowsCount,
      cellsSpanColsCount: cellsSpanColsCount,
      onInsertRowAbove: onInsertRowAbove,
      onInsertRowBelow: onInsertRowBelow,
      onInsertColumnLeft: onInsertColumnLeft,
      onInsertColumnRight: onInsertColumnRight
    }), /*#__PURE__*/_jsx(DeleteDropdownButton, {
      cellsSpanRowsCount: cellsSpanRowsCount,
      cellsSpanColsCount: cellsSpanColsCount,
      onDeleteRow: onDeleteRow,
      onDeleteColumn: onDeleteColumn
    }), /*#__PURE__*/_jsx(MergeSplitButton, {
      showMerge: showMerge,
      showSplit: showSplit,
      onMergeCells: onMergeCells,
      onSplitCells: onSplitCells
    })]
  });
}
export default TableFloatyPopoverBody;